import React, { useEffect, useState } from 'react';
import styles from '../news-tab/NewsTab.module.scss';
import { useGetQuery } from '../../../../../../services/apiCall';
import endpoints from '../../../../../../api/endpoints';
import Text from '../../../../../atoms/text/Text';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../atoms/loader/Loader';
import NewsletterCard from '../../../../../atoms/newsletter-card/NewsletterCard';
import useIsRtl from '../../../../../../app/helpers/isRtl';
const apiUrl = endpoints.news.getNewsletter;

const NewsletterTab = () => {
  const navigate = useNavigate();
  const isRtl = useIsRtl();

  const params = ['4', '1', '?IsActive=true'];
  const { data, error, isLoading, refetch } = useGetQuery({
    apiUrl: apiUrl,
    params: params,
  });

  const [delayDone, setDelayDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setDelayDone(true), 500);
    return () => clearTimeout(timer);
  }, []);

  if (error) return <p>Something went wrong</p>;

  return (
    <div className={styles['cards-container']}>
      {!delayDone || isLoading ? (
        <div className={styles['loader-container']}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={styles.cards} dir={isRtl ? 'rtl' : ''}>
            {data?.items?.map((item) => (
              <NewsletterCard
                key={item?.eventId}
                id={item?.eventId}
                image={`${item?.url}${item?.newsletterImage}`}
                title={item?.title_AR}
                type="newsletter"
                className={styles['newsletter-card']}
              />
            ))}
          </div>

          <div className={styles['view-container']}>
            <button
              className={styles['view-btn']}
              onClick={() => navigate('/news-and-events/news-letter')}
            >
              <Text
                title="common.view_all"
                variant="text-bold-italic-16"
                maxLines={2}
                className={styles.btnTitle}
              />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default NewsletterTab;
